import moment from 'moment';
import get from 'lodash/get';

export const DATE_INPUT_FMT = 'YYYY-MM-DD';

export default function dateComputed(path)
{
    return {
        get() { return moment(get(this, path)).format(DATE_INPUT_FMT); },
        set(v)
        {
            if(v === '')
                return;

            const parsed    = moment(v, DATE_INPUT_FMT);

            let original    = moment(get(this, path));

            if(!original.isValid())
            {
                original = parsed;
            }
            else
            {
                original.year(parsed.year());
                original.month(parsed.month());
                original.date(parsed.date());
            }

            this.$vueSet(this, path, original.valueOf());
        }
    }
}
